if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zoomControl = this.querySelector('[data-nv-zoom]');
        this.zoomControl?.addEventListener('pointerup', (event) => event.stopPropagation());
        this.zoomControl?.addEventListener('click', (event) => {
          event.stopPropagation();
          const enlarged = this.classList.toggle('nv-cx-enlarged');
          this.zoomControl.setAttribute('aria-pressed', String(enlarged));
          this.zoomControl.textContent = enlarged ? this.zoomControl.dataset.labelFit : this.zoomControl.dataset.labelEnlarge;
          const container = this.querySelector('[role="document"]');
          container.scrollLeft = 0;
          container.scrollTop = 0;
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.classList.remove('nv-cx-enlarged');
        if (this.zoomControl) {
          this.zoomControl.setAttribute('aria-pressed', 'false');
          this.zoomControl.textContent = this.zoomControl.dataset.labelEnlarge;
        }
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = 0;
        container.scrollTop = 0;
        if (this.zoomControl) this.zoomControl.hidden = activeMedia.tagName !== 'IMG';

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
